@if(filterColumns){
<div class="table-container">
  @if(customizable){
  @if(showFilterPanel){
  <app-filter-panel [columns]="columns"
                    [tableId]="effectiveTableId"
                    (OnClose)="showFilterPanel = false">
  </app-filter-panel>
  }
  }
  <div class="table-scrollable" [ngStyle]="{'max-height': (IncludePaginator ? '(calc(100% - 56px))' : '')}">
    <table #tableEl class="rms-table" [class.in-edit]="customizable" [style.width.%]="totalTableWidth">
      <colgroup>
        @for (column of visibleColumns; track $index) {
        <col [style.width.%]="column.width">
        }
        <col *ngIf="hasIconsColumn" style="width:56px">       <!-- actions -->
        <col *ngIf="expandable || hasExpandableRow()" style="width:48px"> <!-- expand -->
      </colgroup>
      <thead>
        <tr>
          @if(customizable || HeaderButtons){
          <th [attr.colspan]="visibleColumns.length + (hasIconsColumn ? 1 : 0) + ((expandable || hasExpandableRow()) ? 1 : 0)">
            <div class="dash-toolbar">
              <!-- centered drag/drop host -->
              @if (DragAndDrop) {
              <div class="rms-header-drop-host"
                   [class.dragging]="draggingOverHeader"
                   (click)="openHeaderFileDialog()"
                   (dragover)="onHeaderDragOver($event)"
                   (dragleave)="onHeaderDragLeave($event)"
                   (drop)="onHeaderDrop($event)"
                   role="button"
                   tabindex="0"
                   [attr.aria-label]="DragDropLabel">
                <input #headerFileInput
                       type="file"
                       [attr.accept]="DragAccept || null"
                       [attr.multiple]="DragMultiple ? '' : null"
                       hidden
                       (change)="onHeaderBrowseChange($event)" />
                <div class="inner">
                  <mat-icon>upload</mat-icon>
                  <span class="label">{{ DragDropLabel || 'Drag/Drop file or click to select' }}</span>
                </div>
              </div>
              }

              @if(isDraggingColumn){
              <div class="trash-zone"
                   [class.active]="isDraggingColumn"
                   rmsTrashDrop
                   (columnHide)="onColumnHide($event)">
                <mat-icon>delete</mat-icon>
                <span>Drop here to hide column</span>
              </div>
              }
              @if(customizable){
              <button mat-stroked-button (click)="editTable = !editTable">
                <mat-icon>dashboard_customize</mat-icon>
                {{ editTable ? 'Done' : 'Customize' }}
              </button>
              }

              @if(customizable){
              <button mat-stroked-button [matMenuTriggerFor]="layoutMenu">
                <mat-icon>list_alt</mat-icon>
                Preset Table Layouts {{selectedLayout.LayoutName ? ('(Selected: ' + selectedLayout.LayoutName + ')') : ''}}
              </button>
              <mat-menu #layoutMenu>
                <h4 style="color:#578587">---------- Default Layout ---------</h4>
                @for (layout of DefaultLayout; track layout.LayoutID) {
                <button mat-menu-item (click)="SelectLayout(layout)">{{ layout.LayoutName }}</button>
                }
                <h4 style="color:#578587">---------- Custom Layouts ---------</h4>
                @for (layout of CustomLayouts; track layout.LayoutID) {
                <button mat-menu-item (click)="SelectLayout(layout)">{{ layout.LayoutName }}</button>
                }
                <h4 style="color:#578587">---------- System Layouts ---------</h4>
                @for (layout of SystemLayouts; track layout.LayoutID) {
                <button mat-menu-item (click)="SelectLayout(layout)">{{ layout.LayoutName }}</button>
                }
              </mat-menu>
              }
              <!--<div class="spacer"></div>-->
              @if (editTable) {
              <rms-checkbox [ngModel]="selectedLayout.DefaultLayout || false" (ngModelChange)="selectedLayout.DefaultLayout = $event" [disabled]="(selectedLayout.DefaultLayout ?? false)" label="Default"></rms-checkbox>

              <button mat-button [matMenuTriggerFor]="addMenu">
                <mat-icon>add</mat-icon>Add Column
              </button>
              <mat-menu #addMenu="matMenu" style="padding:5px">
                <div style="margin:5px; height: 200px; overflow:auto; display:flex; flex-direction:column; gap:5px; padding:5px">
                  @for(column of columns; track $index){
                  <div style="border:solid 1px black; border-radius:4px;padding:5px"><rms-checkbox (click)="$event.stopPropagation()" [small]="true" [label]="getColumnLabel(column)" [ngModel]="!column.hidden" (ngModelChange)="column.hidden = !($event); column.width = 10"></rms-checkbox></div>
                  }
                </div>
              </mat-menu>

              @if (!selectedLayout.SystemLayout) {
              <button mat-button (click)="UpdateLayout()"><mat-icon>save</mat-icon>Update</button>
              }
              <button mat-button (click)="onSaveNewLayout()">
                <mat-icon>save_as</mat-icon>Save As New
              </button>
              }
              @if(customizable){<button class="btn-bg-blue" mat-stroked-button (click)="showFilterPanel = !showFilterPanel"><mat-icon style="color:white">filter_list</mat-icon> Filters</button>}
              @for (button of HeaderButtons; track $index) {
              @if (button.menu) {
              <!-- Button WITH menu -->
              <button mat-stroked-button [class]="button.class || 'btn-bg-blue'"
                      [matMenuTriggerFor]="menu"
                      [disabled]="button.disabled"
                      type="button">
                @if (button.icon) {
                <mat-icon>{{ button.icon }}</mat-icon>
                }
                {{ button.label }}
              </button>

              <!-- Menu scoped to this iteration -->
              <mat-menu #menu="matMenu">
                <ng-container *ngFor="let opt of button.menu">
                  <button mat-menu-item type="button" (click)="opt.onAction()">
                    {{ opt.label }}
                  </button>
                </ng-container>
              </mat-menu>
              } @else {
              <!-- Button WITHOUT menu -->
              <button mat-stroked-button [class]="button.class || 'btn-bg-blue'"
                      type="button"
                      [disabled]="button.disabled"
                      (click)="button.onAction?.()">
                @if (button.icon) {
                <mat-icon>{{ button.icon }}</mat-icon>
                }
                {{ button.label }}
              </button>
              }
              }
            </div>
          </th>
          }
        </tr>
        @if(editTable){
        <!-- DRAG ROW (handles + gap drop zones) -->
        <tr class="dragable-column">
          @for(column of visibleColumns; track $index; let i = $index){
          <th [attr.data-col-key]="column.key"
              [class.dragging-out]="i === draggingVisibleIndex"
              [style.text-align]="column.align ?? 'center'"
              [style.background]="headerBackground"
              [style.width.%]="column.width"
              rmsColumnResize
              [columnKey]="column.key"
              (columnResizeStart)="onColumnResizeStart($event)"
              (columnResizeMove)="onColumnResizeMove($event)"
              (columnResizeEnd)="onColumnResizeEnd($event)">

            <!-- LEFT GAP (only on the very first visible column) -->
            <span *ngIf="i === 0"
                  rmsGapDropLeft
                  [gapIndex]="0"
                  (columnReorder)="onColumnReorder($event)"></span>

            <!-- drag handle with custom ghost -->
            <div style="display:flex; justify-content:center; align-items:center"
                 rmsColumnDrag
                 [dragIndex]="i"
                 [dragKey]="column.key"
                 [dragLabel]="getColumnLabel(column)"
                 (dragBegin)="onColDragBegin($event)"
                 (dragEnd)="onColDragEnd($event)">
              <mat-icon>drag_indicator</mat-icon>
            </div>

            <!-- RIGHT GAP (between i and i+1) -->
            <span rmsGapDropRight
                  [gapIndex]="i + 1"
                  (columnReorder)="onColumnReorder($event)"></span>
          </th>
          }
        </tr>
        }

        <!-- LABELS/SORT ROW -->
        <tr [class.dragable-column]="editTable" [style.background]="headerBackground">
          @for(column of visibleColumns; track $index; let i = $index){
          <th [attr.data-col-key]="column.key"
              [class.dragging-out]="i === draggingVisibleIndex"
              [style.width.%]="column.width"
              [class.active-sort]="IncludeSort && !column.removeSort && sortColumn === column.key"
              [attr.aria-sort]="IncludeSort && !column.removeSort ? (sortColumn === column.key ? (sortDirection === 'asc' ? 'ascending' : 'descending') : 'none') : null"
              [attr.tabindex]="IncludeSort && !column.removeSort ? 0 : null"
              (keydown)="onSortKeydown($event, column.key)"
              (click)="setSort(column.key)"
              [title]="!IncludeSort || column.removeSort ? '' : sortColumn !== column.key ? 'Sort ascending by ' + getColumnLabel(column) : sortDirection === 'asc' ? 'Sorted ascending. Click to sort descending.' : 'Sorted descending. Click to remove sorting.'">
            @if(!column.removeSort){
            <div class="sortable" [class.sorting]="sortColumn === column.key">
              @if(column.type === 'checkbox' && column.checkAll){
              <input type="checkbox" class="header-select-all" [attr.aria-label]="'Select all filtered ' + getColumnLabel(column)"
                     [checked]="allFilteredChecked(column)" [indeterminate]="someFilteredChecked(column)"
                     [disabled]="!filteredData.length" (click)="$event.stopPropagation()"
                     (change)="toggleFilteredColumn(column, $any($event.target).checked)">
              }
              <span class="column-label">{{ getColumnLabel(column) }}</span>
              @if(IncludeSort){
              <span class="sort-icon" *ngIf="sortColumn === column.key">
                <mat-icon class="sort-arrow" aria-hidden="true">
                  {{sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward'}}
                </mat-icon>
                <span class="sort-direction">{{sortDirection === 'asc' ? 'ASC' : 'DESC'}}</span>
              </span>
              <!--<span class="sort-icon" *ngIf="sortColumn !== column.key">-->
              <!--<mat-icon class="sort-arrow">arrow_upward_alt</mat-icon>
              <mat-icon class="sort-arrow">arrow_downward_alt</mat-icon>-->
              <!--</span>-->
              }
            </div>
            }
          </th>
          }
          <th *ngIf="hasIconsColumn" style="width:5%; text-align:center">{{ActionsText}}</th>
          <th *ngIf="expandable || hasExpandableRow()" style="width:5%; text-align:right">{{ExpandedText}}</th>
        </tr>

        <!-- SEARCH ROW -->
        <tr style="border-top:0; background:white" *ngIf="IncludeSearch">
          @for(column of visibleColumns; track column; let i = $index){
          <th [class.dragging-out]="i === draggingVisibleIndex" [style.width.%]="column.width">
            @if(true){
            <div class="table-input">
              <mat-icon>search</mat-icon>
              <ng-container [ngSwitch]="column.SearchType">
                <select *ngSwitchCase="'select'"
                        [(ngModel)]="inlineFilter[column.key]"
                        (ngModelChange)="onInlineFilterChange()">
                  <option value="" disabled selected>{{ getColumnLabel(column) }}</option>
                  @for(option of column.dropdownSearchOptions; track $index) {
                  <option [value]="option.value">{{ option.label }}</option>
                  }
                </select>
                <select *ngSwitchCase="'checkbox'"
                        [(ngModel)]="inlineFilter[column.key]"
                        (ngModelChange)="onInlineFilterChange()">
                  <option value="" disabled selected>Filter Checked</option>
                  <option [ngValue]="'checked'">Checked</option>
                  <option [ngValue]="'unchecked'">Unchecked</option>
                </select>

                <input type="date" *ngSwitchCase="'date'"
                       [(ngModel)]="inlineFilter[column.key]"
                       (ngModelChange)="onInlineFilterChange()" />
                <input type="text" *ngSwitchDefault
                       [(ngModel)]="inlineFilter[column.key]"
                       (ngModelChange)="onInlineFilterChange()"
                       [placeholder]="getColumnLabel(column)" />
                <mat-icon *ngIf="inlineFilter[column.key]" class="clear-icon" (click)="clearInlineFilter(column.key)">close</mat-icon>
              </ng-container>
            </div>
            }
          </th>
          }
          <th *ngIf="expandable || hasExpandableRow()" colspan="1"></th>
          <th *ngIf="hasIconsColumn" colspan="1"></th>
        </tr>
      </thead>

      <tbody>
        @for(row of paginatedData; track $index; let i = $index){
        <ng-container>
          <tr class="data-row"
              rmsRowOverlay
              [class.is-even]="(i % 2) === 1"
              [class.is-expanded]="isExpanded(i)"
              [class.clickableRow]="clickableRow"
              [class.expanded-parent]="isExpanded(i)"
              (click)="onClickRow(row)"
              [ngClass]="row.RowClass">
            @for(column of visibleColumns; track column; let ci = $index){
            <td [class.dragging-out]="ci === draggingVisibleIndex"
                (click)="column.clickable ? $event.stopPropagation() : null"
                [ngStyle]="{'width': column.width + '%', 'text-align' : column.align ?? 'center', 'color' : column.textColor ?? ''}">
              @if(shouldHostWatermark(ci, column, row)){
              <div class="row-watermark"
                   [class.cell-only]="row.rowHighlight?.scope !== 'row'"
                   [style.--hl-bg]="row.rowHighlight.background || null"
                   [style.--hl-color]="row.rowHighlight.textColor || null"
                   [style.--hl-justify]="row.rowHighlight.justify || 'left'"
                   [style.--h1-margin-left]="row.rowHighlight.margin || '50%'">
                <div class="watermark-text">{{ row.rowHighlight.text }}</div>
              </div>
              }
              <div class="cell-inner" [ngClass]="getCellClass(column, row)">
                @if (getCellTemplate(column.key); as cellTemplate) {
                  <ng-container *ngTemplateOutlet="cellTemplate; context: { $implicit: row, column: column }"></ng-container>
                } @else {
                <ng-container [ngSwitch]="column.type">
                  <div [ngClass]="row?.[column.key] ? column.columnClass : ''">
                    @if(column.edit){
                    <div class="table-input" [ngStyle]="{background: column.type == 'select' ? 'white': ''}" style="justify-content:center">
                      <mat-icon *ngIf="column.type == 'currency'">attach_money</mat-icon>
                      <input *ngSwitchCase="'number'" type="number" [(ngModel)]="row[column.key]" (change)="column.onAction?.(row)" [min]="getColumnMin(column, row)" [max]="getColumnMax(column, row)" [step]="column.step ?? 1" />
                      <rms-checkbox [small]="true" *ngSwitchCase="'checkbox'" [(ngModel)]="row[column.key]" (change)="column.onAction?.(row)"></rms-checkbox>
                      <input *ngSwitchCase="'currency'" type="number" step="0.01" min="0.00" [(ngModel)]="row[column.key]" (change)="column.onAction?.(row)" />
                      <input *ngSwitchCase="'date'" type="date" (ngModelChange)="setDateValue(row, column.key, $event)" [ngModel]="getDateValue(row, column.key)" (change)="column.onAction?.(row)" />
                      <select *ngSwitchCase="'select'"
                              [(ngModel)]="row[column.key]"
                              (ngModelChange)="column.onAction?.(row)">
                        <option [ngValue]="null" disabled>Select {{ column.label }}</option>
                        @for(option of column.selectOptions; track $index){
                        <option [ngValue]="option.value">{{ option.label }}</option>
                        }
                      </select>
                      <textarea *ngSwitchCase="'textarea'" [(ngModel)]="row[column.key]" (change)="column.onAction?.(row)"></textarea>
                      <input *ngSwitchDefault [(ngModel)]="row[column.key]" (change)="column.onAction?.(row)" />
                    </div>
                    }
                    @else{
                    <div [ngClass]="column.clickable && hasCellValue(column, row) ? 'clickable-text' : ''">
                      <div *ngSwitchCase="'number'" (click)="onClickCell(column, row)" title="{{row[column.key]}}">{{(onFixed(row[column.key], column))}}</div>
                      <div *ngSwitchCase="'date'" (click)="onClickCell(column, row)" title="{{row[column.key]}}">{{((isComputedColumn(column.key) ? computeValue(column.key, row) : row[column.key]) | date: 'MM-dd-yyyy':'UTC')  ?? '--'}}</div>
                      <div *ngSwitchCase="'currency'" (click)="onClickCell(column, row)" title="{{row[column.key]}}">{{((isComputedColumn(column.key) ? computeValue(column.key, row) : row[column.key]) | currency: 'USD' : 'symbol' : (column.format ?? '1.2-2'))  ?? '--'}}</div>
                      <rms-checkbox [small]="true" *ngSwitchCase="'checkbox'" [(ngModel)]="row[column.key]" title="{{row[column.key]}}" [disabled]="true" (click)="onClickCell(column, row)"></rms-checkbox>
                      <div *ngSwitchDefault (click)="onClickCell(column, row)">
                        {{isComputedColumn(column.key) ? computeValue(column.key, row) : row[column.key] ?? '--'}}
                      </div>
                    </div>
                    }
                  </div>
                </ng-container>
                }
              </div>
            </td>
            }

            <td style="width: 5%;" *ngIf="hasIconsColumn" (click)="$event.stopPropagation()">
              <div class="flex-row" style="display:flex; gap:2px; justify-content:center">
                @for (icon of (getIcons ? getIcons(row) : icons); track $index) {
                <mat-icon (click)="icon.action(row, $index)" title="{{icon.title}}">{{ icon.icon }}</mat-icon>
                }
              </div>
            </td>

            @if(expandable){
            <td style="width:5%; text-align:right;" [class.disabled]="!row.expandable" (click)="toggleExpand(i); handleExpand(row)">
              <mat-icon *ngIf="row.expandable" class="expand-icon" [class.expanded]="isExpanded(i)">expand_more</mat-icon>
            </td>
            }

            @if(hasExpandableRow() && !expandable){
            @if(row.expandable){
            @if(row.expandText){
            <td style="width:5%; text-align: right">
              <button style="padding:0 !important" mat-stroked-button (click)="toggleExpand(i, row); handleExpand(row)">{{isExpanded(i) ? row.expandText.hide : row.expandText.show}}</button>
            </td>
            }
            @else{
            <td style="width:5%; text-align:right;" (click)="toggleExpand(i, row); handleExpand(row)">
              <mat-icon class="expand-icon" [class.expanded]="isExpanded(i)">expand_more</mat-icon>
            </td>
            }
            }
            @else{
            <td style="width:5%; text-align:right;"></td>
            }
            }
          </tr>

          <!-- expanded row -->
          <tr *ngIf="isExpanded(i) || row.expanded" class="expand-row" [class.is-even]="(i % 2) === 1">
            <td [attr.colspan]="(columns.length || 0) + (hasIconsColumn ? 1 : 0) + 1">
              <div class="expanded-content">
                <ng-container *ngTemplateOutlet="expandedTemplate; context: { $implicit: row }"></ng-container>
              </div>
            </td>
          </tr>
        </ng-container>
        }
      </tbody>
      @if(footerRows.length){
      <tfoot>
        @for(summary of footerRows; track $index){
        <tr class="table-summary-row">
          @for(column of visibleColumns; track $index){
          <td [style.text-align]="column.align ?? 'center'">{{summary[column.key] ?? ''}}</td>
          }
          @if(hasIconsColumn){<td></td>}
          @if(expandable || hasExpandableRow()){<td></td>}
        </tr>
        }
      </tfoot>
      }
    </table>
  </div>

  <!-- footer: paginator on LEFT, buttons on RIGHT -->
  <div class="paginator-footer" *ngIf="IncludePaginator">
    <mat-paginator [length]="filteredData.length"
                   [pageSize]="pageSize"
                   [pageSizeOptions]="[50, 100, 150]"
                   (page)="onPageChange($event)">
    </mat-paginator>

    <div class="footer-buttons" *ngIf="footerButtons?.length">
      @for(button of footerButtons; track button){
      <button [ngClass]="button.class ?? 'bg-green'" (click)="button.onAction?.()">
        <div style="display:flex; align-items:center">
          <mat-icon *ngIf="button.icon">{{button.icon}}</mat-icon>{{button.label}}
        </div>
      </button>
      }
    </div>
  </div>
</div>
}
